import { FC } from "react";

import { PointShipmentHistory } from "@/features/PointShipmentHistory";

interface HistoryTabProps {
    pointId: string;
}

export const HistoryTab: FC<HistoryTabProps> = ({ pointId }) => {
    return <PointShipmentHistory pointId={pointId} />;
};
